import React from "react";
import { userConstants } from "../../../_constants";
import "../css/section-four.scss";
import Mavovr1 from "../img/manovr-1.jpg";
import Mavovr2 from "../img/manovr-2.jpg";
import Mavovr3 from "../img/manovr-3.jpg";
import Mavovr4 from "../img/manovr-4.jpg";
import Mavovr5 from "../img/manovr-5.jpg";
import Mavovr6 from "../img/manovr-6.jpg";
import Mavovr7 from "../img/manovr-7.jpg";
import Mavovr8 from "../img/manovr-8.jpg";
import InfoCard from "./info-card";

export const SectionFour = ({ hospitalGraphUrl }) => {
  const manovrList = [
    {
      name: "جلسه واکراند واحد خیاط خانه و لاندری",
      src: Mavovr1,
    },
    {
      name: "جلسه واکراند بخش",
      src: Mavovr2,
    },
    {
      name: "جلسه واکراند بخش",
      src: Mavovr3,
    },
    {
      name: " جلسه واکراند بخش اورژانس",
      src: Mavovr4,
    },
    {
      name: " جلسه واکراند بخش بلوک زایمان",
      src: Mavovr5,
    },
    {
      name: " جلسه واکراند واحد خدمات عمومی",
      src: Mavovr6,
    },
    {
      name: " جلسه واکراند واحد فناوری اطلاعات سلامت",
      src: Mavovr7,
    },
    {
      name: "جلسه واکراند واحدهای مداربسته و مخابراط",
      src: Mavovr8,
    },
  ];

  return (
    <div className="section_4">
      <div className="his">
        <p className="title iran-sans_Bold">ارزیابی ایمنی بیمارستان (HSI)</p>
        <InfoCard title="اطلاعات کلی">
          <img
            src={`${userConstants.SERVER_URL}${hospitalGraphUrl}`}
            alt=""
            className="his_image"
          />
        </InfoCard>
      </div>
      <div className="maneuvers_held">
        <p className="title iran-sans_Bold">
          تصاویر واکراند های برگزار شده در بیمارستان
        </p>
        <div className="maneuvers_held_list">
          {manovrList.slice(0, 4).map((m, index) => (
            <div className="maneuvers_held_list_item" key={index}>
              <p className="maneuvers_held_list_item_title iran-sans_Bold">
                {m.name}
              </p>
              <a
                className="pointer"
                href={m.src}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={m.src} alt={m.name} />
              </a>
            </div>
          ))}
        </div>
        <div className="maneuvers_held_list">
          {manovrList.slice(4, 8).map((m, index) => (
            <div className="maneuvers_held_list_item" key={index}>
              <p className="maneuvers_held_list_item_title iran-sans_Bold">
                {m.name}
              </p>
              <a
                className="pointer"
                href={m.src}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={m.src} alt={m.name} />
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
